import { requiredValidator } from "components/Form/Form.utils";
import { Form } from "components/Form/components/Form/Form";
import { TextFormComponent } from "components/Form/components/Text/TextFormComponent";
import { getUserData } from "containers/Auth/Auth.selectors";
import { Field } from "react-final-form";
import { useSelector } from "react-redux";

export const TwoFaCodeField = ({ isRequired }: { isRequired?: boolean }) => (
    <Field
        name="twofaCode"
        id="twofaCode"
        fieldProps={{
            clearable: false,
        }}
        fieldAttr={{
            placeholder: "2FA Code (if enabled)",
        }}
        component={TextFormComponent}
        validate={isRequired ? requiredValidator : undefined}
    />
);

export const TwoFaCodeFieldIfEnabled = () => {
    const userData = useSelector(getUserData);
    const isTwoFaEnabled = userData.is_twofa_enabled;

    return isTwoFaEnabled ? (
        <Form.Row>
            <TwoFaCodeField isRequired />
        </Form.Row>
    ) : null;
};
